import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Input, Modal, ModalBody, Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import classnames from "classnames";
import moment from "moment";
//
import { useModal } from "context/confirm.context";
import cmsHubMembershipApi from "api/membershipApi";
import { catchAsync } from "helpers/general";
import DateTimePickerCustom from "pages/CmsHub/Components/DateTimePicker";
import { PAYMENT_METHOD, PLAN_CODE } from "helpers/constans";

interface Props {
  isOpen: boolean;
  data: any;
  onClose: () => void;
  refresh: () => void;
}
const ModalUpdateMember = (props: Props) => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const [isInput, setIsInput] = useState(true);
  const [loading,setLoading] = useState(false);
  const [isDatePicker, setDatePicker] = useState(true);
  const [loadingSub, setLoadingSub] = useState(false);
  const [isAutoRenewal, setIsAutoRenewal] = useState(false);
  const [tabModal, setTabModal] = useState("1");
  const [detail, setDetail] = useState<any>({});
  const [plans, setPlans] = useState<any>([] as any);
  const tabs = [
    { id: "1", label: t("membership.membership_information") },
    { id: "2", label: t("membership.update_membership") },
  ];
  const paymentMethod = [
    { id: PAYMENT_METHOD.CARD, label: t("membership.card_payment") },
    { id: PAYMENT_METHOD.CASH, label: t("membership.cash_payment") },
  ];
  const planLabel = {
    [PLAN_CODE.BASIC]: t("membership.basic"),
    [PLAN_CODE.STANDARD]: t("membership.standard"),
    [PLAN_CODE.PREMIUM]: t("membership.premium"),
    [PLAN_CODE.ENTERPRISE]: t("membership.enterprise"),
  }

  const createPopupSchema = Yup.object().shape({
    limit_hdd: Yup.number().optional().default(0),
    limit_daily_transfer: Yup.number().optional().default(0),
    amount: Yup.number().optional().default(0),
    point: Yup.number().optional().default(0),
    note: Yup.string().optional().notRequired(),
  });

  const initialValues = {
    limit_hdd: 0,
    limit_daily_transfer: 0,
    point: 0,
    amount: 0,
    note: "",
    valid_to: "",
    plan_code: "",
    is_apply_now: false,
    payment_method: PAYMENT_METHOD.CARD,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: createPopupSchema,
    onSubmit: async (formValue) => {
      let values = {...formValue} as any;
      if (
        (!values.limit_hdd ||
          !values.limit_daily_transfer ||
          !values.point ||
          !values.amount
          || values.limit_hdd == 0
          || values.limit_daily_transfer == 0
          || values.point == 0
          || values.amount == 0
          || !values.valid_to) && values?.plan_code?.length
      ) {
        showModal(
          {
            title: t("membership.check"),
            message: t("membership.membership_notice"),
            submitButtonText: t("membership.check"),
            isHiddenClose: true,
          },
          () => { }
        );
        return;
      };
      if(values?.plan_code?.length){
        values.limit_hdd = typeof values.limit_hdd === "string" ? parseInt(values.limit_hdd) : values.limit_hdd;
        values.limit_daily_transfer = typeof values.limit_daily_transfer === "string" ? parseInt(values.limit_daily_transfer) : values.limit_daily_transfer;
        values.point = typeof values.point === "string" ? parseInt(values.point) : values.point;
        values.amount = typeof values.amount === "string" ? parseInt(values.amount) : values.amount;
        values.payment_method = typeof values.payment_method === "string" ? parseInt(values.payment_method) : values.payment_method;
        values.valid_to = moment(values?.valid_to).format("YYYY-MM-DD");
      } else {
        delete values.limit_hdd;
        delete values.limit_daily_transfer;
        delete values.point;
        delete values.amount;
        delete values.plan_code;
        delete values.valid_to;
      }
      if(isCheckDiffDateValue){
        setLoading(true);
        values.is_apply_now = false;
        await handleChangeMemberShip(values);
        setLoading(false);
        return;
      }
      showModal(
        {
          title: t("membership.check"),
          message: t("membership.when_will_my_membership_changes_be_reflected"),
          submitButtonText: t("membership.apply_now"),
          cancelButtonText: t("membership.apply_next_month"),
          width: "360px",
          isShowIconClose: true
        }, async () => {
          values.is_apply_now = true;
          await handleChangeMemberShip(values)
        }, async () => {
          values.is_apply_now = false;
          await handleChangeMemberShip(values)
        }
      );
    },
  });

  const handleChangeMemberShip = async (values: any) => {
    const [error, _] = await catchAsync(
      cmsHubMembershipApi.cmshubCompanyPlanUpdate(props.data?.company_id, values),
    );
    if (error) {
      toast.error(error?.message || error);
      return;
    }
    setTimeout(() => {
      showModal(
        {
          title: t("membership.check"),
          message: <div>
            {t("membership.your_membership_change_has_been_completed")} 
          </div>,
          submitButtonText: t("membership.check"),
          isHiddenClose: true,
        },
        () => props.onClose()
      );
      props.refresh();
    }, 0);
  }

  const isCheckDiffValue = useMemo(() => {
    const limitHdd = detail?.next_month_plan?.limit_hdd || detail?.limit_hdd;
    const limitDailyTransfer = detail?.next_month_plan?.limit_daily_transfer || detail?.limit_daily_transfer;
    const note = detail?.note;
    const point = detail?.next_month_plan?.point || detail?.point;
    const amount = detail?.next_month_plan?.amount || detail?.amount;
    const planCode = detail?.next_month_plan?.plan_code || detail?.plan_code;
    return formik.values.limit_hdd != limitHdd || formik.values.limit_daily_transfer != limitDailyTransfer
      || formik.values.note != note|| formik.values.point != point || formik.values.amount != amount
      || formik.values.payment_method != detail?.payment_method || formik.values.plan_code != planCode || moment(formik.values.valid_to).format('YYYY-MM-DD') != moment(detail?.valid_to).format('YYYY-MM-DD')
  }, [formik.values, detail]);

  const isCheckDiffDateValue = useMemo(() => {
    const limitHdd = detail?.next_month_plan?.limit_hdd || detail?.limit_hdd;
    const limitDailyTransfer = detail?.next_month_plan?.limit_daily_transfer || detail?.limit_daily_transfer;
    const note = detail?.note;
    const point = detail?.next_month_plan?.point || detail?.point;
    const amount = detail?.next_month_plan?.amount || detail?.amount;
    const planCode = detail?.next_month_plan?.plan_code || detail?.plan_code;
    return formik.values.limit_hdd == limitHdd && formik.values.limit_daily_transfer == limitDailyTransfer
      && formik.values.point == point && formik.values.amount == amount
       && formik.values.plan_code == planCode && (formik.values.payment_method != detail?.payment_method || formik.values.note != note || moment(formik.values.valid_to).format('YYYY-MM-DD') != moment(detail?.valid_to).format('YYYY-MM-DD'))
  }, [formik.values, detail]);

  const handleCancelMembership = async () => {
    const [error] = await catchAsync(
      cmsHubMembershipApi.deactivateMembership(props.data?.company_id),
      setLoadingSub
    );
    if (error) {
      toast.error(error?.message || error);
      return;
    }
    setIsAutoRenewal(false);
    props.refresh();
    showModal(
      {
        title: t("membership.check"),
        message: t("membership.your_membership_has_been_cancelled"),
        submitButtonText: t("membership.check"),
        isHiddenClose: true,
      },
      () => { }
    );
  };

  const handleDestroyMembership = async () => {
    const [error] = await catchAsync(
      cmsHubMembershipApi.cmshubCompanyPlanDestroy(props.data?.company_id),
      setLoadingSub
    );
    if (error) {
      console.log(error);
      toast.error(error?.message || error);
      return;
    }
    setIsAutoRenewal(false);
    props.refresh();
  };

  const handleChangeNumber = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let value = e.target.value;
    if (value.match(/[^0-9]/)) {
      return;
    }
    value = value.replace(/^0+(?=[1-9])/, "");
    if (isNaN(parseInt(value)) || parseInt(value) < 0 || parseInt(value) == 0) {
      value = "0";
    }
    formik.setFieldValue(key, value);
  };

  const getDetail = async () => {
    const [error, result] = await catchAsync(
      cmsHubMembershipApi.cmshubCompanyPlanDetail(props.data?.company_id),
      setLoadingSub
    );
    if (error) {
      console.log(error);
      toast.error(error?.message || error);
      return;
    };
    setDetail(result?.data);
    formik.setValues(defaultValue(result?.data));
  };

  const getMasterDataPlan = async () => {
    const [error, result] = await catchAsync(
      cmsHubMembershipApi.masterdataPlan(),
      setLoadingSub
    );
    if (error) {
      console.log(error);
      toast.error(error?.message || error);
      return;
    };
    setPlans(result?.data);
  }

  const defaultValue = (data: any) => {
    return {
      limit_hdd: data?.next_month_plan?.limit_hdd || data?.limit_hdd,
      limit_daily_transfer: data?.next_month_plan?.limit_daily_transfer || data?.limit_daily_transfer,
      point: data?.next_month_plan?.point || data?.point,
      amount: data?.next_month_plan?.amount || data?.amount,
      note: data?.note,
      payment_method: data?.payment_method,
      valid_to: data?.valid_to,
      plan_code: data?.next_month_plan?.plan_code || data?.plan_code,
      is_apply_now: data?.is_apply_now,
    };
  }

  useEffect(() => {
    if (props.data && props.isOpen) {
      setIsAutoRenewal(props.data?.is_auto_renewal);
    };
  }, [props.data, props.isOpen]);

  useEffect(() => {
    if (props.isOpen) {
      getDetail();
      getMasterDataPlan();
    } else {
      setIsInput(true);
      setDatePicker(true);
      setTabModal("1");
      formik.resetForm();
    }
  }, [props.data, props.isOpen]);

  return (
    <Modal
      isOpen={props.isOpen}
      centered={true}
      scrollable={false}
      style={{ width: "520px", maxWidth: '520px' }}
    >
      <div className="d-flex justify-content-between pt-3 pb-2 px-3 items-center">
        <div></div>
        <div style={{ fontSize: "18px", fontWeight: "700" }}>
          {t("membership.change")}
        </div>
        <div onClick={() => props.onClose()}>
          <i
            className="ri-close-line"
            style={{ fontSize: "20px", cursor: "pointer" }}
          ></i>
        </div>
      </div>
      <ModalBody style={{ height: '595px' }}>
        <Nav className="nav-tabs-custom rounded border-bottom-0 mt-0 gap-3" role="tablist">
          {tabs.map((tab) => (
            <NavItem key={tab.id}>
              <NavLink
                className={classnames("cursor-pointer", {
                  active: tabModal === tab.id,
                })}
                onClick={() => setTabModal(tab.id)}
              >
                {tab.label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <form onSubmit={formik.handleSubmit} style={{ width: "100%", marginTop: "10px", display: "flex", justifyContent: 'space-between', flexDirection: "column", height: 'calc(100% - 47px)' }}>
          <TabContent activeTab={tabModal} className="text-muted">
            <TabPane tabId={"1"} id={"tab-1"}>
              <div className="d-flex flex-column gap-3">
                <div className="d-flex gap-5">
                  <div style={{ width: "150px" }}>
                    <div className="fw-bold">{t("membership.membership_in_use")}</div>
                    <div>{planLabel[detail?.plan_code] || t('membership.membership_not_registered')}</div>
                  </div>
                  <div>
                    <div className="fw-bold">{t("membership.membership_end_date")}</div>
                    <div>{detail?.valid_to ? moment(detail?.valid_to).format("YYYY.MM.DD") : "-"}</div>
                  </div>
                </div>
                <div className="d-flex gap-5">
                  <div style={{ width: "150px" }}>
                    <div className="fw-bold">{t("membership.usage_total")}</div>
                    <div className="d-flex gap-2">
                      <span className="fw-bold">HDD</span>
                      <span>{detail?.hdd}GB / {detail?.limit_hdd}GB</span>
                    </div>
                  </div>
                  <div>
                    <div style={{ height: "21px", width: "1px" }}></div>
                    <div className="d-flex gap-2"><span className="fw-bold">{t("membership.daily_transfer_volume")}</span> {detail?.daily_transfer}GB / {detail?.limit_daily_transfer}GB</div>
                  </div>
                </div>
                <div>
                  {
                    detail?.next_month_plan ? <div className="mb-2" style={{ fontSize: '14px', color: '#1C6BFF' }}>
                      {t('membership.notice_next_month')}
                    </div> : null
                  }
                  <div className="fw-bold mb-1">
                    {t("membership.payment_method")}
                  </div>
                  <div className="d-flex gap-2">
                    {
                      paymentMethod?.map((item: any, index: number) => {
                        return (
                          <button type="button" className="btn w-sm btn-light"
                            key={index} style={{
                              border: Number(formik.values.payment_method) === Number(item?.id) ? "1px solid #25a0e2" : "1px solid #E2E5EB",
                              background: Number(formik.values.payment_method) === Number(item?.id) ? "#EBF1FD" : "white",
                              color: Number(formik.values.payment_method) === Number(item?.id) ? "#25a0e2" : "#9397A1",
                            }}
                            onClick={() => {
                              formik.setFieldValue("payment_method", item?.id);
                            }}
                          >
                            {
                              Number(formik.values.payment_method) === Number(item?.id) && <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M14.3702 5.37271L7.8776 13.875L2.79129 8.4562" stroke="#25a0e2" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            }
                            {item?.label}
                          </button>
                        )
                      })
                    }
                  </div>
                </div>
                <div className="d-flex flex-column gap-1">
                  <div>{t("membership.memo")}</div>
                  <textarea
                    className="form-control"
                    id="jobDescription"
                    rows={8}
                    {...formik.getFieldProps("note")}
                    value={formik.values.note || ""}
                    maxLength={500}
                    style={{
                      resize:"none"
                    }}
                  />
                </div>
              </div>
            </TabPane>
            <TabPane tabId={"2"} id={"tab-2"}>
              <div className="d-flex gap-3 justify-content-between align-items-center">
                <div>
                  <div>{t("membership.change_membership_end_date")}</div>
                  <div>{detail?.valid_to ? moment(detail?.valid_to).format("YYYY.MM.DD") : "-"}</div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="83" height="16" viewBox="0 0 83 16" fill="none">
                  <path d="M82.7071 8.70711C83.0976 8.31658 83.0976 7.68342 82.7071 7.29289L76.3431 0.928932C75.9526 0.538408 75.3195 0.538408 74.9289 0.928932C74.5384 1.31946 74.5384 1.95262 74.9289 2.34315L80.5858 8L74.9289 13.6569C74.5384 14.0474 74.5384 14.6805 74.9289 15.0711C75.3195 15.4616 75.9526 15.4616 76.3431 15.0711L82.7071 8.70711ZM0 8V9H82V8V7H0V8Z" fill="black" />
                </svg>
                <div>
                  <DateTimePickerCustom
                    date={formik.values.valid_to || null}
                    dateFormat="yyyy.MM.dd"
                    isNotFilterTime={true}
                    isNotshowTimeSelect={true}
                    placeholder="YYYY.MM.DD"
                    disabled={isDatePicker}
                    onChange={(value) => {
                      formik.setFieldValue("valid_to", value);
                    }}
                    minDate={moment().format("YYYY-MM-DD")}
                  />
                </div>
              </div>
              <div className="mt-2 d-flex justify-content-end mb-3">
                <button
                  type="button"
                  className={`btn ${!isDatePicker ? "btn-primary" : "btn-secondary"}`}
                  onClick={() => {
                    if (!isDatePicker) {
                      formik.setFieldValue("valid_to", detail?.valid_to);
                    }
                    setDatePicker(!isDatePicker);
                  }}
                  style={{ width: '178px' }}
                >
                  {isDatePicker ? t("membership.change") : t("membership.cancel")}
                </button>
              </div>
              <div className="d-flex gap-2 mt-4 mb-3">
                {
                  plans?.map((item: any, index: number) => {
                    return (
                      <button key={index} type="button" className="btn fs-14 w-100" style={{
                        border: formik.values.plan_code === item?.code ? "1px solid #25a0e2" : "1px solid #E2E5EB",
                        background: formik.values.plan_code === item?.code ? "#EBF1FD" : "white",
                        color: formik.values.plan_code === item?.code ? "#25a0e2" : "#9397A1",
                        whiteSpace: "nowrap"
                      }} onClick={() => {
                        formik.setFieldValue("plan_code", item?.code);
                        if (PLAN_CODE.ENTERPRISE !== item?.code) {
                          formik.setFieldValue("limit_hdd", item?.details?.limit_hdd);
                          formik.setFieldValue("limit_daily_transfer", item?.details?.limit_daily_transfer);
                          formik.setFieldValue("point", Number(item?.details?.point));
                          formik.setFieldValue("amount", item?.amount);
                        }
                      }}>
                        {planLabel[item?.code] || item?.name}
                      </button>
                    )
                  })
                }
              </div>
              <div className="d-flex gap-3 flex-wrap">
                <div className="d-flex gap-2">
                  <div className="d-flex gap-2 align-items-center" >
                    <div style={{ minWidth: "100px" }}>HDD</div>
                    <div className={`wrapper ${isInput ? "disabled" : ""}`}>
                      <Input
                        type="text"
                        className="form-control"
                        {...formik.getFieldProps("limit_hdd")}
                        onChange={(e: any) => handleChangeNumber(e, "limit_hdd")}
                        style={{ textAlign: "right" }}
                        disabled={isInput}
                        maxLength={5}
                      />
                      <div className="prefix">GB</div>
                    </div>
                  </div>
                  <div className="d-flex gap-2 align-items-center" >
                    <div className="text-right" style={{ minWidth: "100px" }}>{t("membership.daily_transfer_volume")}</div>
                    <div className={`wrapper ${isInput ? "disabled" : ""}`}>
                      <Input
                        type="text"
                        className="form-control"
                        {...formik.getFieldProps("limit_daily_transfer")}
                        onChange={(e: any) => handleChangeNumber(e, "limit_daily_transfer")}
                        style={{ textAlign: "right" }}
                        disabled={isInput}
                        maxLength={5}
                      />
                      <div className="prefix">GB</div>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-2">
                  <div className="d-flex gap-2 align-items-center">
                    <div style={{ minWidth: "100px" }}>{t("membership.point")}</div>
                    <div className={`wrapper ${isInput ? "disabled" : ""}`}>
                      <Input
                        type="text"
                        className="form-control"
                        {...formik.getFieldProps("point")}
                        onChange={(e: any) => handleChangeNumber(e, "point")}
                        style={{ textAlign: "right" }}
                        disabled={isInput}
                        maxLength={9}
                      />
                      <div className="prefix">p</div>
                    </div>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <div className="text-right" style={{ minWidth: "100px" }}>{t("membership.payment_amount")}</div>
                    <div className={`wrapper ${isInput ? "disabled" : ""}`}>
                      <Input
                        type="text"
                        className="form-control"
                        {...formik.getFieldProps("amount")}
                        onChange={(e: any) => handleChangeNumber(e, "amount")}
                        style={{ textAlign: "right" }}
                        disabled={isInput}
                        maxLength={12}
                      />
                      <div className="prefix">원</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-2">
                <button
                  type="button"
                  className={`btn ${!isInput ? "btn-primary" : "btn-secondary"}`}
                  onClick={() => {
                    if (!isInput) {
                      formik.setFieldValue("limit_hdd", detail?.next_month_plan?.limit_hdd || detail?.limit_hdd);
                      formik.setFieldValue("limit_daily_transfer", detail?.next_month_plan?.limit_daily_transfer || detail?.limit_daily_transfer);
                      formik.setFieldValue("point", Number(detail?.next_month_plan?.point || detail?.point));
                      formik.setFieldValue("amount", detail?.next_month_plan?.amount || detail?.amount);
                    }
                    setIsInput(!isInput);
                  }}
                  style={{ minWidth: "178px" }}
                >
                  {isInput ? t("membership.change") : t("membership.cancel")}
                </button>
              </div>
              <div className="d-flex gap-2 align-items-center mt-4" style={{ marginLeft: '50px' }}>
                <div>
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={loadingSub || !isAutoRenewal}
                    onClick={() => {
                      showModal(
                        {
                          title: t("membership.check"),
                          message: t("membership.would_you_like_to_cancel_your_membership"),
                          submitButtonText: t("membership.yes"),
                          cancelButtonText: t("membership.no"),
                        },
                        () => handleCancelMembership()
                      );
                    }}
                    style={{ whiteSpace: 'nowrap', maxWidth: "153px" }}
                  >
                    {t("membership.cancel_membership")}
                  </button>
                </div>
                <div style={{ fontWeight: "500", fontSize: "12px", fontFamily: 'hkgrotesk' }}>
                  {t("membership.if_cancel_membership")}
                </div>
              </div>
              <div className="d-flex gap-2 align-items-center mt-2" style={{ marginLeft: '50px' }}>
                <div>
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={loadingSub || !isAutoRenewal}
                    onClick={() => {
                      showModal(
                        {
                          title: t("membership.check"),
                          message: t("membership.do_you_want_to_cancel_your_membership_immediately"),
                          submitButtonText: t("membership.yes"),
                          cancelButtonText: t("membership.no"),
                        },
                        () => handleDestroyMembership()
                      );
                    }}
                    style={{ whiteSpace: 'nowrap', maxWidth: "153px" }}
                  >
                    {t("membership.cancel_membership_2")}
                  </button>
                </div>
                <div style={{ fontWeight: "500", fontSize: "12px", fontFamily: 'hkgrotesk' }}>
                  {t("membership.cancel_membership_desc_2")}
                </div>
              </div>
              {
                detail?.next_month_plan ? <div className="mt-2 text-center" style={{ fontSize: '14px', color: '#1C6BFF' }}>
                  {t('membership.notice_next_month')}
                </div> : null
              }
            </TabPane>
          </TabContent>
          <div className="hstack gap-2 justify-content-center px-5">
            <button
              className="btn btn-soft-secondary fs-14 w-100"
              type="button"
              color="light"
              onClick={() => props?.onClose()}
            >
              {t("cms_media.cancellation")}
            </button>
            <button type="submit" className="btn btn-primary fs-14 w-100" disabled={!isCheckDiffValue}>
              {loading ? <Spinner size="sm me-2"></Spinner> : null}
              {t("cms_media.save")}
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ModalUpdateMember;
